export default __webpack_public_path__ + "static/media/vpManMade.5a9aafa5.svg";